<div class="card">
  @if (_resetPasswordForm) {
    <form novalidate [formGroup]="_resetPasswordForm" (ngSubmit)="onResetPassword()" class="form-horizontal">
      <header class="card-header card-accent">
        <h2 class="card-title">
          <i class="material-icons m-r-10">vpn_key</i>
          {{ 'Modules.Users.Applications.Users.ResetPassword.Title' | translate }}
        </h2>
      </header>
      <div class="card-block">
        <div class="media">
          <mat-icon class="mr-3 align-self-center mat-icon material-icons">info_outline</mat-icon>
          <div class="media-body">
            <small>{{ 'Commons.Validation.Password' | translate }}</small>
          </div>
        </div>
        <div class="form-group m-t-20 row">
          <label class="col-sm-4 col-form-label" for="password">{{ 'Modules.Users.Applications.Users.ResetPassword.Form.NewPassword' | translate }}:</label>
          <div class="col-sm-8">
            <mat-form-field>
              <input type="password" matInput formControlName="password" required />
            </mat-form-field>
            @if (password.errors?.required && password.touched) {
              <p class="error">
                {{'Commons.Validation.Required' | translate : { field: "Modules.Users.Applications.Users.ResetPassword.Form.NewPassword" | translate } }}
              </p>
            }
            @if (password.errors?.pattern && password.touched) {
              <p class="error">
                {{ 'Commons.Validation.Pattern' | translate }}
              </p>
            }
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label" for="confirmPassword">{{ 'Modules.Users.Applications.Users.ResetPassword.Form.ConfirmPassword' | translate }}:</label>
          <div class="col-sm-8">
            <mat-form-field>
              <input type="password" matInput formControlName="confirmPassword" required />
            </mat-form-field>
            @if ((confirmPassword.errors?.required || confirmPassword.errors?.equalTo) && confirmPassword.touched) {
              <p class="error">
                {{ 'Commons.Validation.Compare' | translate: { field1: "Modules.Users.Applications.Users.ResetPassword.Form.NewPassword" | translate, field2: "Modules.Users.Applications.Users.ResetPassword.Form.ConfirmPassword" | translate } }}
              </p>
            }
            @if (confirmPassword.errors?.pattern && confirmPassword.touched) {
              <p class="error">
                {{ 'Commons.Validation.Pattern' | translate }}
              </p>
            }
          </div>
        </div>
      </div>
      <div class="card-footer text-right">
        <button mat-ripple class="btn btn-accent" type="submit" [disabled]="!_resetPasswordForm.valid">
          <i class="material-icons m-r-10">check</i>
          {{ 'Commons.Actions.Confirm' | translate }}
        </button>
      </div>
    </form>
  }
</div>